<template>
  <div class="container-fluid py-4">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique flex-wrap">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-pencil-square fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Modifier un rôle</h2>
      </div>
    </div>

    <!-- Formulaire -->
    <div class="card shadow-sm rounded card-clinique p-4">
      <form @submit.prevent="submitForm">
        <!-- Nom -->
        <div class="mb-3">
          <label for="roleName" class="form-label fw-semibold">Nom du rôle</label>
          <input
            type="text"
            id="roleName"
            v-model="roleName"
            class="form-control form-control-clinique"
            placeholder="Entrez le nom du rôle"
            required
          />
        </div>

        <!-- Permissions par section -->
        <div class="mb-3">
          <label class="form-label fw-semibold">Permissions</label>

          <div v-for="section in sections" :key="section.code" class="mb-3 border-bottom pb-2">
            <!-- Checkbox section principale -->
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                :id="`section-${section.code}`"
                :value="section.code"
                v-model="selectedPermissions"
                @change="toggleSection(section)"
              />
              <label class="form-check-label fw-bold text-primary" :for="`section-${section.code}`">
                {{ section.label }}
              </label>
            </div>

            <!-- Sous-permissions -->
            <div class="ms-4 mt-2" v-if="section.children && section.children.length">
              <div
                v-for="child in section.children"
                :key="child.code"
                class="form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  :id="`perm-${child.code}`"
                  v-model="selectedPermissions"
                  :value="child.code"
                  @change="toggleChild(section, child)"
                />
                <label class="form-check-label" :for="`perm-${child.code}`">
                  {{ child.label }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Boutons -->
        <button type="submit" class="btn btn-lg btn-clinique mt-3">
          <i class="bi bi-pencil-square me-1"></i> Mettre à jour
        </button>
        <router-link to="/type-users" class="btn btn-secondary btn-lg mt-3 ms-2">
          Annuler
        </router-link>
      </form>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      roleName: "",
      selectedPermissions: [],
      sections: [
        { code: "DASHBOARD", label: "Tableau de bord", children: [] },
           {
          code: "PATIENT",
          label: "Patient",
          children: [
            { code: "PATIENT_LIST", label: "Liste des patients" },
            { code: "PATIENT_CREATE", label: "Ajouter un patient" },
            { code: "PATIENT_EDIT", label: "Modifier un patient" },
            { code: "PATIENT_DELETE", label: "Suppression d'un patient" },
            
          ]
        },
        {
          code: 'Dossier Patient',
          label: 'Dossier',
           children: [
            { code: "PATIENT_DOSSIER", label: "Dossier d'un patient" },
            { code : "VIEW_INFORMATION_PERSONNEL_PATIENT", label: "Voir information personnel du patient"},
            { code : "IMPRESSION_FICHE_PATIENT", label: "Imprimer fiche patient"},
            { code : "VIEW_ASSURANCE_PATIENT", label: " Voir assurances du patient"},
            { code : "VIEW_SECTION_CONSULTATION_PATIENT", label: " Voir consultation du patient"},
            { code: "CONSULT_CREATE", label: "Créer consultation" },
            { code: "CONSULT_PAIEMENT", label: "Payer une consultation" },
            { code: "CONSULT_ANNULER_PAIEMENT", label: "Annuler le paiement d'une consultation" },
            { code: "CONSULT_IMPRESSION", label: "Imprimer le reçu de consultation" },
            { code: "CONSULT_SUPPRESSION", label: "Supprimer une consultation" },
            { code : "VIEW_ORDONNANCE_PATIENT", label: "Voir les ordonnances du patient"},
            { code : "VIEW_ANALYSE_PATIENT", label: "Voir les analyses du patient"},
            { code : "VIEW_HOSPITALISATION_PATIENT", label: "Voir les hospitalisations du patient"},
            { code : "VIEW_AUTRES_SERVICES_PATIENT", label: "Voir les autres service médical"},
            { code : "VIEW_AUTRES_SERVICES_FACTURE_PATIENT", label: "Générer facture service médical"},
             {code : "VIEW_AUTRES_SERVICES_VIEW_FACTURE_PATIENT", label: "Voir détails de la facture service médical"},

            
          ]

        },
        {
          code: "CONSULTATION",
          label: "Consultation",
          children: [
            { code: "CONSULT_VIEW", label: "Voir consultations" },
            { code: "CONSULT_TRAITER", label: "Traiter une consultation" },
            
          ]
        },
        {
          code: "HOSPITALISATION",
          label: "Hospitalisation",
          children: [
            { code: "HOSP_VIEW", label: "Voir hospitalisations" },
            { code: "HOSP_DESTAILS", label: "Voir détails hospitalisations" },
            { code: "HOSP_CREATE", label: "Nouvelle hospitalisation" },
            { code: "HOSP_PAIEMENT", label: "Payer une hospitalisation" },
            { code: "HOSP_EDIT", label: "Modification hospitalisation" },
            { code: "HOSP_DELETE", label: "Supprimer une hospitalisation" },
            { code: "HOSP_IMPRESSION", label: "Impression hospitalisation" },
            { code: "HOSP_CLOTURE", label: "Clôturé une hospitalisation" },
             { code: "HOSP_CLOTURE_ANNULE", label: "Annuler la clôture d'une hospitalisation" },
             { code: "CONFIG_PAIEMENT_HOSPITALISATION", label: "Paiement  d'hospitalisation"},
          ]
        },
        {
          code: "PHARMACIE",
          label: "Pharmacie",
          children: [
            { code: "VIEW_PHARMACIE", label: "Voir pharmacie" },
           /* { code: "MEDICAMENT_LIST", label: "Liste des médicaments" },
           { code: "MEDICAMENT_CREER", label: "Création des médicaments" },
            { code: "MEDICAMENT_MODIFICATION", label: "Modification des médicaments" },
            { code: "MEDICAMENT_DETAILS", label: "Détails des médicaments" },
            { code: "MEDICAMENT_SUPRESSION", label: "Suppression des médicaments" },*/

             { code : "PRODUIT_LIST", label: "Liste des produits"},
            { code : "PRODUIT_UPDATE", label: "Modification des produits"},
            { code : "PRODUIT_SUPPRESSION", label: "Suppressions des produits"},
            { code : "PRODUIT_CREATION", label: " Création  des produits"},

            
            { code: "LISTE_APPROVISIONNEMENT", label: "Liste des approvisionnements" },
            { code: "CREER_APPROVISIONNEMENT", label: "Création des approvisionnements" },
            { code: "Voir_APPROVISIONNEMENT", label: "Details des approvisionnements" },
            { code: "VERROUILLER_APPROVISIONNEMENT", label: "Vérrouiller approvisionnements" },
            { code: "DEVERROUILLER_APPROVISIONNEMENT", label: "Déverrouiller  approvisionnements" },
            { code: "EDIT_APPROVISIONNEMENT", label: "Modification des approvisionnements" },
            { code: "DELETE_APPROVISIONNEMENT", label: "Suppression des approvisionnements" },
            
            { code: "LISTE_VENTE", label: "Faire la vente" },
            { code: "EXPORTER_LISTE_VENTE", label: "Exporter la liste des Ventes" },
            { code: "IMPRIMER_LISTE_VENTE", label: "Imprimer la liste des Ventes" },
            { code: "NOUVELLE_VENTE", label: "Faire une nouvelle Vente" },
            { code: "ANNULER_VENTE", label: "Annuler Vente" },

            {code: "LOT_PRODUIT", label: "Liste des lots "}


            //{ code: "STOCK_VIEW", label: "Stocks et mouvements" }
        


          ]
        },
        {
          code: "TRANSACTION",
          label: "Transaction",
          children: [
            { code: "TRANS_LIST_CONSULTATION", label: "Liste des transactions consultations" },
            { code: "TRANS_LIST_AUTRES_SERVICES", label: "Liste des transactions autres services" },
            { code: "TRANS_LIST_CONSULTATION_IMPRESSION", label: "Imprimer la Liste des transactions consultations" },
            { code: "TRANS_LIST_CONSULTATION_EXPORT", label: "Exporter la Liste des transactions autres services" },
            { code: "TRANS_LIST_AUTRES_SERVICES_IMPRESSION", label: "Imprimer la Liste des transactions autres services" },
            { code: "TRANS_LIST_AUTRES_SERVICES_EXPORT", label: "Exporter la Liste des transactions autres services" },
         
           
          ]
        },
        {
          code: "CONFIG",
          label: "Configuration",
          children: [
            { code: "CONFIG_LISTE_ASSURANCE", label: "Liste des assurances" },
            { code: "CONFIG_CREER_ASSURANCE", label: "Créer une assurance" },
            { code: "CONFIG_MODIFIER_ASSURANCE", label: "Modification d'assurance" },
            { code: "CONFIG_SUPPRESSION_ASSURANCE", label: "Suppression d'assurance" },

            { code: "CONFIG_LISTE_TYPE_CONSULTATION", label: "Liste des types de consultations" },
            { code: "CONFIG_CREER_TYPE_CONSULTATION", label: "Créer type de consultation" },
            { code: "CONFIG_MODIFIER_TYPE_CONSULTATION", label: "Modification type de consultation" },
            { code: "CONFIG_SUPPRESSION_TYPE_CONSULTATION", label: "Suppression type de consultation" },

            { code: "CONFIG_LISTE_TYPE_EXAMEN", label: "Liste des types d\'examen" },
            { code: "CONFIG_CREER_TYPE_EXAMEN", label: "Créer type d\'examen" },
            { code: "CONFIG_MODIFIER_TYPE_EXAMEN", label: "Modification type d\'examen" },
            { code: "CONFIG_SUPPRESSION_TYPE_EXAMEN", label: "Suppression type d\'examen" },

               { code: "CONFIG_LISTE_TYPE_SERVICE", label: "Liste des types services" },
            { code: "CONFIG_CREER_TYPE_SERVICE", label: "Créer type service" },
            { code: "CONFIG_MODIFIER_TYPE_SERVICE", label: "Modification type service" },
            { code: "CONFIG_SUPPRESSION_TYPE_SERVICE", label: "Suppression type service" },

            { code: "CONFIG_LISTE_SERVICE", label: "Liste des services" },
            { code: "CONFIG_CREER_SERVICE", label: "Créer un service" },
            { code: "CONFIG_MODIFIER_SERVICE", label: "Modification un service" },
            { code: "CONFIG_SUPPRESSION_SERVICE", label: "Suppression un service" },

            { code: "CONFIG_LISTE_FREQUENCE", label: "Liste des posologies" },
            { code: "CONFIG_CREER_FREQUENCE", label: "Créer posologies" },
            { code: "CONFIG_MODIFIER_TYPE_EXAMEN", label: "Modification posologie" },
            { code: "CONFIG_SUPPRESSION_TYPE_EXAMEN", label: "Suppression posologie" },

            

            { code: "CONFIG_LISTE_DUREE_MEDICAMENT", label: "Liste des durée de médicament" },
            { code: "CONFIG_CREER_DUREE_MEDICAMENT", label: "Créer durée médicament" },
            { code: "CONFIG_MODIFIER_DUREE_MEDICAMENT", label: "Modification durée médicament" },
            { code: "CONFIG_SUPPRESSION_DUREE_MEDICAMENT", label: "Suppression durée médicament" },


            { code: "CONFIG_LISTE_CONDITIONNEMENT", label: "Liste des conditionnements"},
            { code: "CONFIG_CREER_CONDITIONNEMENT", label: "Création des conditionnements"},
            { code: "CONFIG_MODIFIER_CONDITIONNEMENT", label: "Modification des conditionnements"},
            { code: "CONFIG_SUPPRESSION_CONDITIONNEMENT", label: "Suppression des conditionnements"},

            { code: "CONFIG_MOYEN_PAIEMENT", label: "Liste des moyens de paiements"},
            { code: "CONFIG_CREER_MOYEN__PAIEMENT", label: "Création des moyens de paiements"},
            { code: "CONFIG_MODIFIER_MOYEN_PAIEMENT", label: "Modification des moyens de paiements"},
            { code: "CONFIG_SUPPRESSION_MOYEN_PAIEMENT", label: "Suppression des moyens de paiements"},

            { code: "CONFIG_TYPE_HOSPITALISATION", label: "Liste des types d'hospitalisation"},
            { code: "CONFIG_CREER_TYPE_HOSPITALISATION", label: "Création des types d'hospitalisation"},
            { code: "CONFIG_MODIFIER_TYPE_HOSPITALISATION", label: "Modification des types d'hospitalisations"},
            { code: "CONFIG_SUPPRESSION_TYPE_HOSPITALISATION", label: "Suppression des types d'hospitalisation"},

            { code: "CONFIG_TYPE_CHAMBRE", label: "Liste des types chambres"},
            { code: "CONFIG_CREER_TYPE_CHAMBRE", label: "Création des types chambres"},
            { code: "CONFIG_MODIFIER_TYPE_CHAMBRE", label: "Modification des types chambres"},
            { code: "CONFIG_SUPPRESSION_TYPE_CHAMBRE", label: "Suppression des types chambres"},

            { code: "CONFIG_CHAMBRE", label: "Liste des chambres"},
            { code: "CONFIG_CREER_CHAMBRE", label: "Création des chambres"},
            { code: "CONFIG_MODIFIER_CHAMBRE", label: "Modification des chambres"},
            { code: "CONFIG_SUPPRESSION_CHAMBRE", label: "Suppression des chambres"},

            { code: "CONFIG_LIT", label: "Liste des lits"},
            { code: "CONFIG_CREER_LIT", label: "Création des lits"},
            { code: "CONFIG_MODIFIER_LIT", label: "Modification des lits"},
            { code: "CONFIG_SUPPRESSION_LIT", label: "Suppression des lits"},

           
          ]
        },
        {
          code: "ADMIN",
          label: "Administration",
          children: [
            { code: "VIEW_CONFIGURATION_SYSTEME", label: "Configuration système" },
            { code: "CREATE_CONFIGURATION_SYSTEME", label: "Création Configuration système" },
            { code: "EDIT_CONFIGURATION_SYSTEME", label: "Modification Configuration système" },
           
            { code: "ADMIN_LISTE_ROLE", label: "Liste des rôles utilisateurs"},
            { code: "ADMIN_CREER_ROLE", label: "Création des rôles utilisateurs"},
            { code: "ADMIN_MODIFIER_ROLE", label: "Modification des rôles utilsiateurs"},
            { code: "ADMIN_SUPPRESSION_ROLE", label: "Supression des rôles"},
            { code: "ADMIN_LISTE_UTILISATEUR", label: "Liste des utilisateurs" },
            { code: "ADMIN_CREATION_UTILISATEUR", label: "Création  des utilisateurs" },
            { code: "ADMIN_EDIT_UTILISATEUR", label: "Modification  des utilisateurs" },
            { code: "ADMIN_DESACTIVER_UTILISATEUR", label: "Désactivation  des utilisateurs" },
            { code: "ADMIN_SUPPRESSION_UTILISATEUR", label: "Suppression  des utilisateurs" }
          ]
        }
      ]
    };
  },
  created() {
    this.loadRole();
  },
  methods: {
    async loadRole() {
      try {
        const response = await api.getItem("type_users", this.id);
        const role = response.data;
        this.roleName = role.nom;
        this.selectedPermissions = role.permissions || [];
      } catch (error) {
        console.error("Erreur chargement rôle:", error);
      }
    },
    toggleSection(section) {
      if (this.selectedPermissions.includes(section.code)) {
        section.children.forEach(child => {
          if (!this.selectedPermissions.includes(child.code)) {
            this.selectedPermissions.push(child.code);
          }
        });
      } else {
        this.selectedPermissions = this.selectedPermissions.filter(
          code => code !== section.code && !section.children.map(c => c.code).includes(code)
        );
      }
    },
    toggleChild(section, child) {
      // si un enfant est coché → forcer le parent
      if (this.selectedPermissions.includes(child.code)) {
        if (!this.selectedPermissions.includes(section.code)) {
          this.selectedPermissions.push(section.code);
        }
      } else {
        // si aucun enfant n'est coché → enlever le parent
        const hasOtherChildren = section.children.some(c => this.selectedPermissions.includes(c.code));
        if (!hasOtherChildren) {
          this.selectedPermissions = this.selectedPermissions.filter(code => code !== section.code);
        }
      }
    },
    async submitForm() {
      if (!this.roleName.trim()) {
        alert("Le nom du rôle est obligatoire");
        return;
      }
      const payload = {
        nom: this.roleName.trim(),
        updatedAt: new Date().toISOString(),
        permissions: this.selectedPermissions
      };
      try {
        await api.updateItem("type_users", this.id, payload);
        this.$router.push("/roles");
      } catch (error) {
        console.error("Erreur mise à jour rôle:", error);
      }
    }
  }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}
.form-control-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 8px 12px;
}
.form-control-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
}
</style>
